import { IProject } from '@/modules/dap/interfaces';
import { dateService } from '@/services/date.service';

export class Project implements IProject {
  description = '';
  id = 0;
  idClient = 0;
  limitPercentSuperior = 0.1;
  limitPercentInferior = 0.1;
  initialDateProject = dateService.parseToMoment().startOf('month').toDate();
  initialHistoryPeriod = dateService.parseToMoment().subtract(1, 'month').startOf('month').toDate();
  finalHistoryPeriod = dateService.parseToMoment().subtract(1, 'month').startOf('month').toDate();
  idMarketShareReferenceType = 1;
  isSelected = false;
  name = '';
  hasSubProjects = false;
  rapStatus = 0;
  qtdMonths = 0;
  qtdStoreProjects = 0;
  idProjectType = 0;
  projectMktShareReferenceDefaults = [];
  storeProjects = [];
  subProjects = [];
  families = {};
  industryProjections = [];
  createdAt = new Date();
  createdBy = new Date();
}
